export const getMimeTypeFa = (mType) => {
  if (!mType) {
    return null;
  }

  let faIcon = null

  switch (mType.split('/')[0]) {
    case 'image':
      faIcon = 'fa-file-image-o';
      break;
    case 'audio':
      faIcon =  'fa-file-audio-o';
      break;
    case 'video':
      faIcon = 'fa-file-video-o';
      break;
    default:
      break;
  }
  
  if(faIcon === null){
    faIcon = 'fa-file-o';
    switch (mType) {
      case 'application/pdf':
        faIcon = 'fa-file-pdf-o';
        break;
      case 'text/plain':
        faIcon = 'fa-file-text-o';
        break;
      case 'text/html':
      case 'application/json':
        faIcon = 'fa-file-code-o';
        break;
      case 'application/gzip':
      case 'application/zip':
        faIcon = 'fa-file-archive-o';
        break;
      default:
        break;
    }
  }

return faIcon;

};
